import * as React from "react";
import {Row} from "react-bootstrap";
import "./HeadlinePane.css"
import HeadlinePaneCardContainer from "./HeadlinePaneCardContainer/HeadlinePaneCardContainer";
import {Tweet} from "../../../../model/Tweet";

interface HeadlineItems {
  headlines: Tweet[],
}

const HeadlinePane: React.FC<HeadlineItems> = (props) => (
    <Row>
    {
      props.headlines.slice(0, 3).map((newsItem, index) => {
        return <HeadlinePaneCardContainer key={index} isFirst={index === 1} newsItem={newsItem} />
      })
    }
    </Row>
)

export default HeadlinePane;
